export default function UnsupportedPreview({ type }) {
    return (
      <div className="unsupported-preview">
        <h3>Preview not available</h3>
        <p>
          This file type ({type}) can’t be previewed in the browser yet.
        </p>
        <p className="hint">
          You can still download it from the ZIP.
        </p>
      </div>
    );
  }